<template>
  <div class="background-main">
    <v-container
      style="height: 100%;">
      <v-row 
        style="height: 100%;"
        align="center" 
        justify="center">
        <v-col cols="12" md="4" sm="6">
          <v-card
            class="border-radius my-10"
            flat
            elevation="5"
            style="background: #00ACC1;">
            <div class="pb-6">
              <v-img
                class="ma-auto"
                contain
                height="250"
                width="250"
                alt="VENOM"
                :src="require('@/assets/image/network.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#00ACC1">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <div class="px-5 py-8"
              style="background: #FFF; border-radius: 15px;">
              <div class="px-3 mb-6">
                <p class="title mb-2">
                  Integrated Field Collection
                </p>

                <p class="body-2 font-weight-light line-text-first">
                  Web CRM Monitoring System with Cloud Base to Improve Team Performance Efficiency.
                </p>
              </div>

              <ValidationObserver ref="observer">
                <v-form class="text-left mb-6">
                  <ValidationProvider name="Username" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="login"
                      outlined
                      dense
                      color="00ACC1"
                      placeholder="Username"
                      v-model="form.username"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Password"
                    rules="required|min:5|max:20"
                    v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="login"
                      class="mt-2 mb-1"
                      outlined
                      color="00ACC1"
                      dense
                      placeholder="Password"
                      v-model="form.password"
                      :type="show ? 'text' : 'password'"
                      :counter="20"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div class="text-center">
                <v-alert 
                  type="error" 
                  text 
                  dense 
                  prominent 
                  v-show="message.error !== ''"
                  v-html="message.error">
                </v-alert>

                <v-btn
                  block
                  color="#00ACC1"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  v-on:keyup.enter="login"
                  @click="login"
                  class="body-2 font-weight-bold white--text text-capitalize">
                  <v-icon size="20" class="mr-2">mdi-login-variant</v-icon>
                  Login Admin
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { TokenService } from "../../service/Storage.Service";
  import { get, post, put, destroy } from "../../service/Axios";
  import firebase from "firebase";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web',
          fcm_token: ''
        },
        process: {
          form: false
        },
        message: {
          error: ''
        }
      }
    },
    methods: {
      async login() {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          
          await post(`admin/login`, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            if (res.status === 200) {

              let user = res.results.data,
                  menu = [
                    {
                      label: 'Beranda',
                      icon: 'mdi-view-dashboard',
                      link: '/dashboard'
                    }
                  ]

              if (user.role === 'admin' && user.position === 'marketing') {
                menu.push(
                  {
                    label: 'Calon Peserta',
                    icon: 'mdi-card-account-details-outline',
                    link: '/candidate'
                  },
                  {
                    label: 'Pengumuman',
                    icon: 'mdi-bullhorn-outline',
                    link: '/announcement'
                  }
                )
              } else if (user.role === 'admin' && user.position === 'kolektor') {
                menu.push(
                  {
                    label: 'Penugasan',
                    icon: 'mdi-human-scooter',
                    link: '/assignment'
                  },
                  {
                    label: 'Pengumuman',
                    icon: 'mdi-bullhorn-outline',
                    link: '/announcement'
                  }
                )
              } else {
                menu.push(
                  {
                    label: 'Penugasan',
                    icon: 'mdi-human-scooter',
                    link: '/assignment'
                  },
                  {
                    label: 'Absensi',
                    icon: 'mdi-account-clock-outline',
                    link: '/attendance'
                  },
                  {
                    label: 'Calon Peserta',
                    icon: 'mdi-card-account-details-outline',
                    link: '/candidate'
                  },
                  {
                    label: 'Pengguna',
                    icon: 'mdi-account-group-outline',
                    link: '/user'
                  },
                  {
                    label: 'Config Radius',
                    icon: 'mdi-map-marker-path',
                    link: '/radius'
                  },
                  {
                    label: 'Pengumuman',
                    icon: 'mdi-bullhorn-outline',
                    link: '/announcement'
                  }
                )
              }

              // JIKA SUDAH TERDAFTAR DI GOOGLE AUTH
              firebase.auth().signInWithEmailAndPassword('venomamj@gmail.com', 'kosong2x')
              .then(responseGoogle => {
                console.log(responseGoogle)

                TokenService.saveToken(
                  res.results.token,
                  JSON.stringify(user),
                  JSON.stringify(menu)
                )

                window.location = `${process.env.BASE_URL}dashboard`
              }).catch(error => {
                console.log(error)
              })

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>

<style>
  .background-main {
    height: 100%;
    background-image: linear-gradient(to top, #00ACC1, #000000);
  }
</style>